import * as types from 'modules/predefinedMessages/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @type {boolean?} State */
const initialState = false;

const setReady = () => true;

export default createReducer(initialState, {
  [types.APPLICATION_READY_SUCCESS]: setReady,
  [types.APPLICATION_READY_FAILURE]: setReady,
});
